

import React from 'react';
import CustomVisualSettings from './pages/CustomVisualSettings';
import { Route, Routes } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './components/auth/authConfig';
import SigninWidget from './components/auth/SigninWidget'
import UserAdministration from './pages/UserAdministration'
import PBIReports from './components/reports/PowerBiReports';
import useAutoLogout from './components/auth/AutoLogout';
import PersonaAdministration from './pages/PersonaAdministration';
import RolesAdministration from './pages/RolesAdministration';
import ReportAdministration from './pages/ReportAdministration';
import DepartmentPage from './pages/DepartmentPage';
import Overview from './pages/Overview';
import PageManagement from './pages/PageManagement';
import RequirePageAccess from './components/layout/RequirePageAccess';
import { UserAssignedPagesProvider } from './context/UserAssignedPagesContext';


const App = ({instance}) => {
  const idleWarningDialog = useAutoLogout(); // Automatically logs out after inactivity, warns after 1 minute of inactivity

  
  return (
    <MsalProvider instance={msalInstance}>
      <UserAssignedPagesProvider>
        {idleWarningDialog}
        <Routes>
          <Route path="/" element={<SigninWidget />} />
          <Route path="/DepartmentManagement" element={<DepartmentPage />} />
          <Route path="/settings/visuals" element={<CustomVisualSettings />} />
          <Route path="/overview/:groupid" element={<Overview />} />
          <Route path="/reports/:ReportID/view" element={<PBIReports/>}/>

           <Route path="/UserAdministration" element={<RequirePageAccess pageKey="/UserAdministration"><UserAdministration /></RequirePageAccess>} />
          <Route path="/ReportAdministration" element={<RequirePageAccess pageKey="/ReportAdministration"><ReportAdministration /></RequirePageAccess>} />
          <Route path="/RolesAdministration" element={<RequirePageAccess pageKey="/RolesAdministration"><RolesAdministration /></RequirePageAccess>} />
          <Route path="/PersonaAdministration" element={<RequirePageAccess pageKey="/PersonaAdministration"><PersonaAdministration /></RequirePageAccess>} />
          <Route path="/PageManagement" element={<RequirePageAccess pageKey="/PageManagement"><PageManagement /></RequirePageAccess>} />


        </Routes>
      </UserAssignedPagesProvider>
    </MsalProvider>
  );
};

export default App;

